module.exports = {
    apiKey: "AIzaSyAFFFVNTMuhR4nYuEetlVTMdLiN2jcTbjc",
    authDomain: "rubbish-ee2d0.firebaseapp.com",
    rubbishUrl: "https://qr-dev.rubbish.love",
    projectId: "rubbish-ee2d0",
    storageBucket: "rubbish-ee2d0.appspot.com",
    messagingSenderId: "98262958131",
    appId: "1:98262958131:web:7f413bd4ef08152aebe346"
};